export const LOG_ACTIONS = {
  CREATED: "Created",
  ACTIVATED: "Activated",
  DEACTIVATED: "Deactivated",
  UPDATED: "Updated",
  DUPLICATED: "Duplicated",
  ASSIGNED: "Assigned",
  REMOVED: "Removed",
  SYNCED: "Synced",
  CLAIMED: "Claimed",
  VOIDED: "Voided",
  REQUESTED: "Requested",
  DOWNLOADED: "Downloaded",
};

export const LOG_TYPES = {
  CATEGORIES: "Categories",
  LOCATIONS: "Locations",
  Venues: "Venues",
  Packages: "Packages",
  Currency: "Currency",
  Shortcuts: "Shortcuts",
  NOTIFICATIONS: "Notifications",
  HOMEPAGE:"Homepage",
  AGE_VALIDATION: "Age Validation",
  SHOREX: "Shore Excursion",
  SHOREX_TRANSACTION: "Shore Excursion Transaction",
  ENTERTAINMENT_RVC: "Entertainment Revenue Center",
  ENTERTAINMENT_TRANSACTION: "Entertainment Transaction",
  REPORT_DOWNLOADS: "Report Downloads",
}

// Sub-entity tag shown on each entry under LOG_TYPES.ENTERTAINMENT_RVC, since
// that one type covers Revenue Center/Itemizer/Menu Item actions together.
export const ENTERTAINMENT_LOG_CATEGORIES = {
  RVC: "Revenue Center",
  ITEMIZER: "Itemizer",
  MENU_ITEM: "Menu Item",
};